import { Action, createReducer, on } from "@ngrx/store";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import * as LocalesActionTypes from "../../actions/locales/locales.actions";

export interface LocaleState {
  localesList: any[];
  localesExcel: any[];
  localesTableConfig: ColumnSorterInfo[];
  locale: any;
  created: boolean;
  isLoading: boolean;
  totalLocales: number;
}

export const initialState: LocaleState = {
  localesList: null,
  localesExcel: null,
  localesTableConfig: null,
  locale: null,
  created: false,
  isLoading: false,
  totalLocales: 0,
};

const localesReducer = createReducer(
  initialState,
  on(LocalesActionTypes.resetLocaleState, () => initialState),
  on(LocalesActionTypes.resetLocale, (state) => {
    return {
      ...state,
      locale: null,
      error: null,
    };
  }),
  on(
    LocalesActionTypes.getLocalesList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as LocaleState)
  ),
  on(LocalesActionTypes.loadLocalesList, (state, { response }) => {
    return {
      ...state,
      localesList: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      totalLocales: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
      isLoading: false,
      error: null,
    };
  }),
  on(
    LocalesActionTypes.getExcelLocalesList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as LocaleState)
  ),
  on(LocalesActionTypes.loadExcelLocalesList, (state, { response }) => {
    return {
      ...state,
      localesExcel: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(
    LocalesActionTypes.getLocale,
    (state, { code }) =>
      ({
        ...state,
        error: null,
        code: code,
        created: false,
        isLoading: true,
      } as LocaleState)
  ),
  on(LocalesActionTypes.loadLocale, (state, { response }) => {
    return {
      ...state,
      locale: (response as any).result ? (response as any).result : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(LocalesActionTypes.createLocale, (state, { locale }) => ({
    ...state,
    locale: locale?.result || null,
    error: null,
  })),
  on(LocalesActionTypes.resetLocale, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(LocalesActionTypes.updateLocale, (state, { locale }) => ({
    ...state,
    locale: locale?.result || null,
    error: null,
  })),
  on(LocalesActionTypes.getLocalesTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(LocalesActionTypes.loadLocalesTableConfig, (state, { response }) => {
    return {
      ...state,
      localesTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(LocalesActionTypes.saveLocalesTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(LocalesActionTypes.localeLoadEnd, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: LocaleState | undefined, action: Action) {
  return localesReducer(state, action);
}
